import React from 'react';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <span className="footer-col">© {year} Tanmay Rajurkar</span>
        <span className="footer-col footer-colophon">
          Set in Instrument Serif, Archivo &amp; JetBrains Mono · written, designed &amp; built by hand
        </span>
        <nav className="footer-col footer-socials" aria-label="Social links">
          <a href="https://github.com/tanmayrajurkar" target="_blank" rel="noreferrer">GitHub</a>
          <a href="https://www.linkedin.com/in/tanmay-rajurkar-254305227/" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://x.com/tanmay_rajurkar" target="_blank" rel="noreferrer">X</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
